import Segmented from "components/BaseWidgets/Segmented";
import "./style.scss";

function HeaderSegment({ data, onChange = () => {} }) {
  return (
    <Segmented
      className="connect-segment"
      options={data.map(({ label, key }) => ({
        label,
        value: key,
      }))}
      onChange={onChange}
    />
  );
}

export default HeaderSegment;
